/**
 * @mixin
 * @description Esse mixins é auxiliar a aba VPL
 * @requires {@link BusinessPlanCore} requer o mixin base para o `formData` e o `resource`.
 * @example
 * mixins: [BusinessPlanFinancial]
 */
export default {
  methods: {
    /**
     * Força a atualização da tabela de VPL caso a aba esteja disponível
     */
    async reloadVPL() {
      this.$refs.vpl?.doLoad();
    },
    /**
     * Atualiza as rubricas vinculadas ao Business Plan.
     * O método `doLoad` do BusinessPlanCore já traz as rubricas vinculadas, se houver.
     * As rubricas vinculadas ficam em `formData.rubricas`.
     */
    async reloadRubricas() {
      try {
        const response = await this.resource.get(this.businessPlanId);
        this.formData.rubricas = response?.data?.rubricas || [];
      } catch {
        this.formData.rubricas = [];
      }
    }
  }
};
